<template>
    <baidu-map
        class="service-baidu-map"
        :center="center"
        :zoom="zoom"
        :scroll-wheel-zoom="true"
        @ready="handleReady"
        ref="baiduMap">
            <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
            <bm-driving
                :start="drivingData.start"
                :end="drivingData.end"
                :auto-viewport="true"
                :waypoints="drivingData.waypoints"
                @markersset="(data)=>markersset(data, 'start')"
                @searchcomplete="handleSearchComplete"
                :panel="false"
            ></bm-driving>
            <bm-driving
                v-if="forecastData.waypoints.length"
                :start="forecastData.start"
                :end="forecastData.end"
                :auto-viewport="true"
                @markersset="(data)=>markersset(data, 'end')"
                @polylinesset="forecastStyle"
                :panel="false"
            ></bm-driving>
            <bm-overlay
                pane="labelPane"
                class="marks-style"
                v-for="(point, index) in drivingPoints" :key="index"
                @draw="(data) => drawMarks(data, index)"
            ></bm-overlay>
            <bm-overlay
                pane="labelPane"
                :class="{'label-style': true}"
                @draw="draw">
                <div>{{stage}}</div>
            </bm-overlay>
    </baidu-map>
</template>
<script>
import LuShu from 'bmaplib.lushu';
export default {
    data() {
        return {
            map: null,
            BMap: null,
            zoom: 17,
            center: { lng: 116.404, lat: 39.915 },
            drivingData: {
                start: {
                    lng: '',
                    lat: ''
                },
                end: {
                    lng: '',
                    lat: ''
                },
                waypoints: []
            },
            drivingPoints: [],
            lushuData: [],
            pathLen: 0,
            index: 0,
            forecastData: {
                start: {
                    lng: '',
                    lat: ''
                },
                end: {
                    lng: '',
                    lat: ''
                },
                waypoints: []
            },
            waypoints: []
        };
    },
    props: {
        trackings: {
            type: Array,
            default() {
                return [];
            }
        },
        polylinePath: {
            type: Array,
            default() {
                return [];
            }
        },
        stage: {
            type: String,
            default() {
                return '';
            }
        }
    },
    methods: {
        // 扁平化数组
        flatArr(arr) {
            return arr.reduce((pre, next) => {
                return pre.concat(Array.isArray(next) ? this.flatArr(next) : next);
            }, []);
        },
        forecastStyle(routes) {
            for(var i=0;i<routes.length;i++){
                routes[i].getPolyline().setStrokeWeight(5);
                routes[i].getPolyline().setStrokeOpacity(1);
                routes[i].getPolyline().setStrokeColor('#cdc9c9');
                routes[i].getPolyline().setStrokeStyle('dashed');
            }
        },
        handleReady({ BMap, map }) {
            this.map = map;
            this.BMap = BMap;
            // 自动获取展示的比例
            this.adjustMapZoomAndCenter(this.polylinePath);
            this.getDrivingData();
            this.handelLushuMarker();
        },
        adjustMapZoomAndCenter(points) { // 为在地图上显示所有点，调整缩放级别和中心点
            var view = this.map.getViewport(eval(points));
            this.zoom = view.zoom;
            this.center = view.center;
        },
        getDrivingData() {
            const todayTime = new Date().getTime();
            this.pathLen = this.polylinePath.length;
            this.forecastData.waypoints = [];
            // 前端虚拟数据
            this.polylinePath.forEach(item => {
                if (new Date(item.time).getTime() > todayTime) {
                    this.forecastData.waypoints.push({ lng: item.lng, lat: item.lat, time: new Date(item.time).getTime() });
                } else {
                    this.drivingData.waypoints.push({ lng: item.lng, lat: item.lat, time: new Date(item.time).getTime() });
                }
            });
            // 根据time排序节点
            const lastwlength = this.forecastData.waypoints.length;
            const waylength = this.drivingData.waypoints.length;
            // 已完成的路线开始结束
            this.drivingData.start = new this.BMap.Point(this.drivingData.waypoints[0].lng, this.drivingData.waypoints[0].lat);
            this.drivingData.end = new this.BMap.Point(this.drivingData.waypoints[waylength - 1].lng, this.drivingData.waypoints[waylength - 1].lat);
            // 未完成的路线开始结束点
            if (this.forecastData.waypoints.length) {
                this.forecastData.waypoints.unshift(this.drivingData.waypoints[waylength - 1]);
                this.forecastData.start = new this.BMap.Point(this.forecastData.waypoints[0].lng, this.forecastData.waypoints[0].lat);
                this.forecastData.end = new this.BMap.Point(this.forecastData.waypoints[lastwlength].lng, this.forecastData.waypoints[lastwlength].lat);
            }
            // this.handleWaypoints(); // 后端筛选 前端显示所有点 waypoints
            this.drivingPoints = [this.drivingData.start, ...this.drivingData.waypoints, this.drivingData.end];
        },
        handleWaypoints(gap = 1) { //获取途径点
            for(let i = gap; i < this.pathLen - 1 ; i += gap ) { // 每隔 gap 个位置选取点
                this.drivingData.waypoints.unshift({ lng: this.polylinePath[i].lng, lat: this.polylinePath[i].lat });
            }
        },
        markersset(routes, type) { // 处理原始图标
            const startIcon = new this.BMap.Icon(require('./images/start.png'), new this.BMap.Size(35,35), { anchor: new this.BMap.Size(14, 33) }),
                endIcon = new this.BMap.Icon(require('./images/end.png'), new this.BMap.Size(35,35), { anchor: new this.BMap.Size(14, 33) });
            let startMarker = {};
            let endMarker = {};
            const hasEnd = this.flatArr(this.trackings).findIndex(t => t.nodeAction === 'SIGN') > -1;
           
            this.map.removeOverlay(routes[0].marker); //删除起点图标
            this.map.removeOverlay(routes[routes.length - 1].marker);//删除终点图标
            for(let i = 1; i < routes.length - 1; i++) {
                let marker = routes[i].Um; // 删除途径点的图标及点击事件
                this.map.removeOverlay(marker);
            }
            if (type === 'start') {
                startMarker = new this.BMap.Marker(routes[0].marker.getPosition() ,{ icon: startIcon });
                this.map.addOverlay(startMarker); // 新增定位图标
                if (hasEnd) {
                    endMarker = new this.BMap.Marker(routes[routes.length - 1].marker.getPosition() ,{ icon: endIcon });
                    this.map.addOverlay(endMarker);
                }
            } else if (type === 'end' && this.forecastData.waypoints.length) {
                endMarker = new this.BMap.Marker(routes[routes.length - 1].marker.getPosition() ,{ icon: endIcon });
                this.map.addOverlay(endMarker);
            }
        },
        handleSearchComplete(dResult) {
            if (++this.index === 3) {
                this.index = 0; // 防止出现多个路书
                if (dResult != null && dResult.getNumPlans() > 0) {
                    const routePlan = dResult.getPlan(0); // 第一条方案
                    const routeNum = routePlan.getNumRoutes(); // 方案包含的线路的个数
                    let arrPois = [];
                    if (routeNum > 0) {
                        arrPois = arrPois.concat(routePlan.getRoute(routeNum - 1).getPath()); // 路线的地理坐标点数组
                        this.handleLuShu(arrPois);
                    }
                }
            }
        },
        handleLuShu(arrPois) { // 处理路书数据
            let lushuData = arrPois.slice(parseInt(-arrPois.length/2));
            let speed = lushuData.length > 1000 ? 120000
                : lushuData.length > 800 ? 80000
                    : lushuData.length > 500 ? 60000
                        : lushuData.length > 200 ? 50000
                            : lushuData.length > 100 ? 20000 : 10000; // 处理路书速度
            let icon; // 小车图片
            if(document.body.offsetWidth > 480) {
                icon = new this.BMap.Icon(require('./images/track_car.png'), {width: 55, height: 22},{anchor:new this.BMap.Size(27, 13)}); 
            } else {
                icon = new this.BMap.Icon(require('./images/track_car_x1.png'), {width: 40, height: 16},{anchor:new this.BMap.Size(27, 13)}); 
            }
            const lushu = new LuShu(this.map, lushuData, {
                autoView: false, // 是否开启自动视野调整，如果开启那么路书在运动过程中会根据视野自动调整
                icon: icon,
                speed: speed,
                enableRotation: true, // 是否设置marker随着道路的走向进行旋转
                landmarkPois: []
            });
            lushu.start();
        },
        handelLushuMarker() { // 处理路书车辆旋转方向，修改lushu源码
            let _this = this;
            LuShu.prototype._addMarker = function () {
                if (this._marker) {
                    this.stop();
                    this._map.removeOverlay(this._marker);
                    clearTimeout(this._timeoutFlag);
                }
                this._overlay && this._map.removeOverlay(this._overlay);
                var marker = new _this.BMap.Marker(this._path[0]);
                this._opts.icon && marker.setIcon(this._opts.icon);
                this._map.addOverlay(marker);
                // marker.setAnimation(BMAP_ANIMATION_DROP); // // 取消路书掉下动画
                this._marker = marker;
                this.setRotation();  //设置小车起点方向
            };
            LuShu.prototype.setRotation = function(prePos,curPos,targetPos){  // 修改小车旋转方向
                let me = this,
                    deg = 0,
                    secPoint = _this.drivingPoints[_this.drivingPoints.length - 2],
                    lastPoint = _this.drivingPoints[_this.drivingPoints.length - 1];
                // 不止起始站点，还有途径站点，因为终点和途径站点最后一战可能重合
                if (_this.drivingPoints.length > 2) {
                    secPoint = _this.drivingPoints[_this.drivingPoints.length - 3],
                    lastPoint = _this.drivingPoints[_this.drivingPoints.length - 2];
                }
                curPos =  me._map.pointToPixel(new _this.BMap.Point(secPoint.lng, secPoint.lat));
                targetPos = me._map.pointToPixel(new _this.BMap.Point(lastPoint.lng, lastPoint.lat));
                if(targetPos.x != curPos.x){
                    let tan = (targetPos.y - curPos.y)/(targetPos.x - curPos.x),
                        atan  = Math.atan(tan);
                    deg = atan * 360 / ( 2 * Math.PI );
                    if(targetPos.x < curPos.x){
                        deg = -deg + 90 + 90;
                    } else {
                        deg = -deg;
                    }
                    me._marker.setRotation(-deg);   
                }else {
                    let disy = targetPos.y- curPos.y,
                        bias = 0;
                    if(disy > 0)
                        bias = -1;
                    else
                        bias = 1;
                    me._marker.setRotation(-bias * 90);  
                }
                return;
            };
        },
        draw({el, BMap, map}) { // 设置状态信息
            const drivingWaypoints = this.drivingData.waypoints;
            const {lng, lat} = drivingWaypoints[drivingWaypoints.length-1];
            const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat));
            el.style.left = pixel.x + 15 + 'px';
            el.style.top = pixel.y  + 10 + 'px';
        },
        drawMarks({el, BMap, map}, index) { // 设置途径点打点
            const {lng, lat} = this.drivingPoints[index];
            const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat));
            el.style.left = pixel.x - 6 + 'px';
            el.style.top = pixel.y - 4 + 'px';
            if(!index || index === this.drivingPoints.length - 1) {
                el.style.opacity = 0; // 隐藏起点终点打点
            }            
        }
    }
};
</script>
<style lang="less">
    .anchorBL {
        display: none;
    }
    .service-baidu-map {
        width: 100%;
        height: 100%;
        .label-style {
            width: .75rem;
            height: .28rem;
            line-height: .28rem;
            font-size: .14rem;
            background-color: #4285f5;
            border-radius: 18px;
            overflow: hidden;
            color: #fff;
            text-align: center;
            position: absolute;
        }
        .marks-style {
            width: 0.03rem;
            height: 0.03rem;
            border-radius: 50%;
            background-color: #fff;
            border: 0.03rem solid #0088eb;
            position: absolute;
        }
    }
    @media screen and (max-width: 480px) {
        .service-baidu-map {
            .label-style {
                width: 0.54rem;
                height: 0.22rem;
                line-height: .22rem;
                border-radius: 10px;
                font-size: 12px;
            }
            .marks-style {
                width: 0.02rem;
                height: 0.02rem;
            }
            /* .BMap_Marker {
                img {
                    position: absolute;
                    width: 25px;
                    height: 25px;
                    background-size: 100%;
                    top: 10px;
                    left: 4px;
                } 
            } */
        }
    }
</style>